// Колесо мыши не должно менять числа в полях.
//
// Поле <input type="number"> (в формах товара это цена, количество, размеры)
// браузер крутит колесом, пока в поле стоит курсор: ввели цену 6000, прокрутили
// окно товара к «Сохранить», а указатель стоял над полем — сохранилось 5998
// или 6002. Так на сайт попали цены 5999, 16002, 24999 (найдены 06.10 и 11.10);
// тем же путём могло меняться количество.
//
// Защита одна на всё приложение: колесо над таким полем снимает с него курсор —
// число остаётся, окно прокручивается дальше. Ввод с клавиатуры не меняется.
// Ставится один раз при запуске (src/index.tsx); возвращает функцию снятия.
export function guardNumberInputsFromWheel(doc: Document = document): () => void {
  const onWheel = (e: WheelEvent) => {
    const el = doc.activeElement;
    if (el instanceof HTMLInputElement && el.type === 'number' && e.target === el) {
      el.blur();
    }
  };
  // capture — успеть до того, как браузер изменит число
  doc.addEventListener('wheel', onWheel, { capture: true, passive: true });
  return () => doc.removeEventListener('wheel', onWheel, { capture: true });
}
